export class OMOperator 
{
    id           : number		   ; 
	loginName    : string		   ;
	authLevel    : number		   ;
	authorization: string		   ;
	enabled      : number | boolean;

	public static isKind( operator: any){
		return  	operator 	
				&&	operator.id
				&&	operator.loginName
				&&	operator.authLevel
				&&	operator.authorization
				&&	operator.enabled
	}
}